import './List.scss';
import Component from './List.js';
export default Component;
